<wl-card heading = "Land Record">

  <h3 class="text-center">Land record updation</h3>
  <form novalidate [formGroup]="landRecordForm" class="formWidth" #formDirective="ngForm" [formGroup]="landRecordForm"
  (ngSubmit)="landRecordUpdate(formDirective)">
    <mat-select formControlName="district" placeholder="District" class="w-full" >
      <mat-option value="Tirupati">Tirupati</mat-option>
    </mat-select>
    <br> <br> <br>
    <mat-select formControlName="mandal" placeholder="Mandal" class="w-full mt-neg1rem" (selectionChange)="mandalSelected($event.value)">
      <mat-option value="checker">Gudur</mat-option>    
    </mat-select>
    <br> <br>

    <mat-form-field class="w-full" >
    <input type="text" matInput placeholder="Village Name" formControlName="villageName" readonly>
    </mat-form-field>
    <mat-form-field class="w-full" >
    <input type="text" matInput placeholder="Survey Number" formControlName="surveyNumber"  readonly >
    </mat-form-field>
    <div class="text-center">
      <button class="mybutton" [disabled]="!landRecordForm.valid">Verify</button>
    </div>

  </form>
</wl-card>